import styled from "styled-components";

export const CardWrapper = styled.div`
  padding-top: 4px;
  padding-bottom: 36px;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
`;

export const DateLabel = styled.div`
  color: #494746;
  font-family: "Nunito";
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;

export const CardContainer = styled.div`
  width: 100%;
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const CardHeader = styled.div`
  align-self: stretch;
  padding-right: 24px;
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  gap: 32px;
  ${({ theme }) => theme.smartphone} {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    padding-right: 0;
  }
`;

export const HeaderBadgesGroup = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 32px;
  ${({ theme }) => theme.smartphone} {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
`;

export const DueBlock = styled.div`
  background-color: #0bbef0;
  padding: 12px 24px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;
  ${({ theme }) => theme.smartphone} {
    padding: 4px 24px;
  }
`;

export const DueLabel = styled.span`
  font-family: "Nunito";
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  color: #ffffff;
  white-space: nowrap;
  ${({ theme }) => theme.smartphone} {
    font-size: 16px;
  }
`;

export const DueNumber = styled.span`
  font-family: "Nunito";
  font-size: 28px;
  font-weight: 800;
  line-height: 32px;
  color: #ffffff;
  ${({ theme }) => theme.smartphone} {
    font-size: 20px;
    line-height: 28px;
  }
`;

export const TypeTag = styled.div`
  padding: 4px 24px;
  border-radius: 4px;
  overflow: hidden;
  background-color: ${({ color }) => color || "#0BBEF0"};
  color: #ffffff;
  font-family: "Nunito";
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  white-space: nowrap;
  display: flex;
  align-items: center;
  ${({ theme }) => theme.smartphone} {
    margin-left: 16px;
  }
`;

export const CampaignInfo = styled.div`
  height: 32px;
  padding-right: 8px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 4px;
  overflow: hidden;
  flex: 1;
  ${({ theme }) => theme.smartphone} {
    height: auto;
    flex: none;
    align-self: stretch;
    padding: 0 16px;
    flex-wrap: wrap;
  }
`;

export const CampaignLabel = styled.span`
  text-align: right;
  color: #475061;
  font-family: "Nunito";
  font-size: 20px;
  font-weight: 400;
  line-height: 24px;
  white-space: nowrap;
  ${({ theme }) => theme.smartphone} {
    font-size: 16px;
  }
`;

export const CampaignName = styled.span`
  text-align: right;
  color: #475061;
  font-family: "Nunito";
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  ${({ theme }) => theme.smartphone} {
    font-size: 16px;
    white-space: normal;
    overflow: visible;
    text-overflow: unset;
    text-align: left;
  }
`;

export const CardBody = styled.div`
  align-self: stretch;
  padding: 8px 24px;
  display: inline-flex;
  justify-content: flex-start;
  align-items: flex-end;
  gap: 32px;
  ${({ theme }) => theme.smartphone} {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    padding: 8px 16px;
  }
`;

export const LeftColumn = styled.div`
  flex: 1;
  align-self: stretch;
  padding: 8px 16px;
  border-radius: 8px;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 32px;
  ${({ theme }) => theme.smartphone} {
    padding: 8px 0;
    gap: 16px;
  }
`;

export const TotalPaidLabel = styled.div`
  color: #475061;
  font-family: "Nunito";
  font-size: 24px;
  font-weight: 400;
  line-height: 32px;
  ${({ theme }) => theme.smartphone} {
    font-size: 16px;
    line-height: 24px;
  }
`;

export const TotalPaidAmount = styled.div`
  display: inline-flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 12px;
`;

export const TotalPaidCurrency = styled.span`
  color: #0bbef0;
  font-family: "Nunito";
  font-size: 28px;
  font-weight: 800;
  line-height: 32px;
  ${({ theme }) => theme.smartphone} {
    font-size: 20px;
    line-height: 28px;
  }
`;

export const TotalPaidValue = styled.span`
  color: #0bbef0;
  font-family: "Nunito";
  font-size: 28px;
  font-weight: 800;
  line-height: 32px;
  ${({ theme }) => theme.smartphone} {
    font-size: 20px;
    line-height: 28px;
  }
`;

export const DownloadSection = styled.div`
  align-self: stretch;
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  ${({ theme }) => theme.smartphone} {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
`;

export const DownloadLabel = styled.span`
  color: #475061;
  font-family: "Nunito";
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;

export const DownloadButton = styled.button`
  width: 216px;
  height: 40px;
  padding: 8px;
  background-color: #0bbef0;
  border: none;
  border-radius: 48px;
  display: inline-flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  color: #ffffff;
  font-family: "Nunito";
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
  &:hover {
    opacity: 0.9;
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  ${({ theme }) => theme.smartphone} {
    width: 136px;
    height: 32px;
    padding: 4px 8px;
  }
`;

export const DownloadIcon = styled.div`
  width: 20px;
  height: 20px;
  background-image: url(/assets/images/excel.png);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
`;

export const RightColumn = styled.div`
  flex: 1;
  align-self: stretch;
  padding: 8px 16px;
  border-radius: 8px;
  display: inline-flex;
  ${({ theme }) => theme.smartphone} {
    padding: 8px 0;
  }
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;

export const DetailRow = styled.div`
  align-self: stretch;
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  gap: 24px;
  ${({ theme }) => theme.smartphone} {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
`;

export const DetailLabel = styled.div`
  flex: 1;
  min-width: 0;
  display: inline-flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  color: #475061;
  font-family: "Nunito";
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
`;

export const DetailAmountGroup = styled.div`
  width: 200px;
  flex-shrink: 0;
  align-self: stretch;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  ${({ theme }) => theme.smartphone} {
    width: auto;
    align-self: stretch;
    justify-content: flex-start;
    gap: 4px;
  }
`;

export const DetailCurrencyPrefix = styled.span`
  color: #475061;
  font-family: "Nunito";
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
`;

export const DetailAmount = styled.span`
  color: ${({ negative }) => (negative ? "#FF317B" : "#475061")};
  font-family: "Nunito";
  font-size: 16px;
  font-weight: 800;
  line-height: 24px;
`;

export const IVANote = styled.div`
  color: #475061;
  font-family: "Nunito";
  font-size: 10px;
  font-weight: 400;
  line-height: 16px;
`;

export const Divider = styled.hr`
  display: none;
`;
